import { render } from "./SpaTreatmentGuests.vue?vue&type=template&id=e1172a7a"
import script from "./SpaTreatmentGuests.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentGuests.vue?vue&type=script&lang=js"

import "@/shared/css/guests.css?vue&type=style&index=0&lang=css&external"
import "./SpaTreatmentGuests.vue?vue&type=style&index=1&id=e1172a7a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__